module.exports = __webpack_public_path__ + "img/Main-logo.a63be852.png";